export const centsToDollarsDisplay = (cents?: number, unsigned: boolean = false): string => {
	if (!cents) return (0).toFixed(2);

	return ((unsigned ? Math.abs(cents) : cents) / 100).toFixed(2);
};

export const displayCentsWithDollarSign = (cents?: number): string => {
	const sign = cents !== undefined && cents < 0 ? "-" : "";

	return `${sign}$${centsToDollarsDisplay(cents, true)}`;
};

export const formatToDisplayTime = (dateString: string): string => {
	const date = new Date(dateString);

	// Format time (12:20 PM)
	const hours = date.getHours();
	const minutes = date.getMinutes();
	const period = hours >= 12 ? "PM" : "AM";
	const displayHours = hours % 12 || 12;
	const timeStr = `${displayHours}:${minutes.toString().padStart(2, "0")} ${period}`;

	// Format date (Mar 20, 2025)
	const months = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec",
	];
	const month = months[date.getMonth()];
	const day = date.getDate();
	const year = date.getFullYear();
	const dateStr = `${month} ${day}, ${year}`;

	return `${timeStr}, ${dateStr}`;
};
